module.exports = __webpack_public_path__ + "static/media/light_icn_map_pin_bus_lex_selected.cdc9bb8d.svg";